import { Component, Injector, Input, OnChanges, SimpleChanges, HostBinding } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SettingsCountingBaseComponent } from '@rift/components/settings/counting/shared/settings/base/SettingsCountingBase.Component';
import { RegisterBaseModel } from '@rift/models/restapi/RegisterBase.Model';
import { ZoneTypeEnum, ZoneTypeEnumHelpers } from '@shared/enum/ZoneType.Enum';
import { ProcessMonitorServiceProcess } from '@shared/service/processmonitor/ProcessMonitor.Service.Process';

@Component({
    selector: 'rift-settings-counting-zone',
    templateUrl: './Settings.Counting.Zone.Component.html',
    styleUrls: ['./Settings.Counting.Zone.Component.scss']
})
export class SettingsCountingZoneComponent extends SettingsCountingBaseComponent implements OnChanges {
    public static className: string = 'SettingsCountingZoneComponent';
    public static zoneTypeDefault: ZoneTypeEnum = ZoneTypeEnum.deferred;

    @HostBinding()
    public id: string = 'rift-settings-counting-zone';

    public ZoneTypeEnum = ZoneTypeEnum;

    public form: FormGroup;
    public formValuesChangeProcess: ProcessMonitorServiceProcess;

    @Input()
    public register: RegisterBaseModel & { zoneType: ZoneTypeEnum } = null;

    public constructor(
        private readonly _formBuilder: FormBuilder,
        private readonly _injector: Injector) {
        super(_injector);

        this.formValuesChangeProcess = this.processMonitorService.getProcess(SettingsCountingZoneComponent.className, 'Form values change');

        this.form = this._formBuilder.group(
            {
                zoneType: ['', Validators.compose([Validators.required])],
            }
        );

        this.addSubscription(this.observableHandlerBase(this.form.controls.zoneType.valueChanges, this.formValuesChangeProcess).subscribe(value => {
            if (!this.isNullOrUndefined(this.register)) {
                this.register.zoneType = value;
            }
        }), this.formValuesChangeProcess);

        this.formGroupTracker.track(this.form);

        this.initConnectionState();
    }

    public getSettingsDescription(): string {
        return this.isNullOrUndefined(this.register) ? '' : ZoneTypeEnumHelpers.toFullLongName(this.register.zoneType);
    }

    public get hasChanges(): boolean {
        return this.isNullOrUndefined(this.register) ? false : this.register.propertyHasChanges('zoneType');
    }

    public get isValid(): boolean {
        return this.isValidBase;
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (!this.isNullOrUndefined(changes.register) && !this.isNullOrUndefined(changes.register.currentValue)) {
            this.register = changes.register.currentValue;
            this.setDefaults();
            this.setFormValues();
        }
    }

    protected offline(): void {
        super.offline();
        this.form.disable();
    }

    protected online(): void {
        super.online();
        this.form.enable();
    }

    private setDefaults(): void {
        if (this.isNullOrUndefined(this.register.zoneType)) {
            this.register.zoneType = SettingsCountingZoneComponent.zoneTypeDefault;
        }
    }

    private setFormValues(): void {
        this.form.controls.zoneType.setValue(this.isNullOrUndefined(this.register.zoneType) ? SettingsCountingZoneComponent.zoneTypeDefault : this.register.zoneType, { emitEvent: false });
    }
}
